export enum OfflineLevelEnum {
    CheckingConnection = 0,
    Online = 1,
    BadConnectionDetected = 2,
    Offline = 3,
}
